import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed, onMounted } from "vue";
import { useSitesStore } from "@/stores/v2";
import { SitesService } from "@/services/v2/sites";
import { useLoading } from "@/composables/useLoading";

import SitesList from "@/components/v2/Dashboard/Sites/Lists/SitesList.vue";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import LoadingScreen from "@/components/v2/Loaders/LoadingScreen.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardSitesPage',
  setup(__props) {

const { withLoading, isLoading } = useLoading();

const sites = computed(() => useSitesStore().getSites);

const init = async () => {
    await withLoading(async () => {
        const sites = await SitesService.getUserSites();
        useSitesStore().setSites(sites)
    })
};

onMounted(init);

return (_ctx: any,_cache: any) => {
  return (_unref(isLoading))
    ? (_openBlock(), _createBlock(LoadingScreen, {
        key: 0,
        text: 'Loading sites'
      }))
    : (_openBlock(), _createBlock(LayoutMain, { key: 1 }, {
        mainArea: _withCtx(() => [
          _createVNode(SitesList, { sites: sites.value }, null, 8, ["sites"])
        ]),
        _: 1
      }))
}
}

})